export default __webpack_public_path__ + "static/media/eesti_keel.924be5dd.png";